module.exports = __webpack_public_path__ + "img/sapphire.eb31f2e.jpg";